import { Dispatch } from "redux";
import { encryptedTGLink, EncryptedTGLinkActionTypes, EncryptedTGLinkCreateAction} from "../../types/Encryption/encryptionTGLink";
import axios from "axios";


const initialEncryptedData: encryptedTGLink = {
    link: '',
};

interface ErrorResponse {
    code: number;
    message: string;
}

export const getEncryptedTGLink = (operator: string, rTag: string, betcardCode: string): any => {
    return async (dispatch: Dispatch<EncryptedTGLinkCreateAction>) => {
        try {
            dispatch({ type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_DATA });
            const response = await axios.get('/api/referral/tg-deep-link', {
                params: {
                    operator: operator,
                    rtag: rTag,
                    betcard_code: betcardCode
                },
                headers: { Accept: 'application/json' },
                
                paramsSerializer: params => {
                    const searchParams = new URLSearchParams();
                    for (const key in params) {
                        if (Array.isArray(params[key])) {
                            params[key].forEach((value: any) => {
                                searchParams.append(key, value);
                            });
                        } else {
                            searchParams.append(key, params[key]);
                        }
                    }
                    return searchParams.toString();
                },
                withCredentials: false
            });
            if (response.data) {
                dispatch({ type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_SUCCESS, payload: response.data });
            } else {
                dispatch({ type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_SUCCESS, payload: initialEncryptedData });
            }
        } catch (error: any) {

            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                if (typeof error.response.data === 'string') {
                    errorPayload = {
                        code: error.response.status,
                        message: error.response.data,
                    }
                } else {
                    const { code, message } = error.response.data;
                    errorPayload = { code, message };
                }
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_ERROR, payload: errorPayload });
        }
    }
}
